/** API error with optional field-level validation errors. */
export class ApiError extends Error {
  readonly code: string;
  readonly status: number;
  readonly fieldErrors?: Record<string, string[]>;

  constructor(
    message: string,
    options: { code?: string; status?: number; fieldErrors?: Record<string, string[]> } = {}
  ) {
    super(message);
    this.name = 'ApiError';
    this.code = options.code ?? 'UNKNOWN';
    this.status = options.status ?? 500;
    this.fieldErrors = options.fieldErrors;
  }
}

export type ApiErrorBody = {
  code?: string;
  message?: string;
  fieldErrors?: Record<string, string[]>;
};
